var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"center"},[_c('h1',[_vm._v(_vm._s(_vm.message))])]),_c('div',{staticClass:"center"},[_c('router-link',{attrs:{"to":{ name: 'userhome' }}},[_vm._v(" Back home ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }